module.exports = __webpack_public_path__ + "img/iPhone14ProMax.44926859.png";